// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1wQ3F","nav":"Menu_nav__3q9xg","menuLink":"Menu_menuLink__fJtNT","langDropdown":"Menu_langDropdown__9J5Ey","menuLinkActive":"Menu_menuLinkActive__1jAMn"};